/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    InternalApiRerunPeriodicScenarioForPeriodRequest,
    InternalApiRerunPeriodicScenarioForPeriodRequestFromJSON,
    InternalApiRerunPeriodicScenarioForPeriodRequestToJSON,
    InternalApiRerunPeriodicScenarioRequest,
    InternalApiRerunPeriodicScenarioRequestFromJSON,
    InternalApiRerunPeriodicScenarioRequestToJSON,
    InternalApiRerunScenariosForPersonsByIdsRequest,
    InternalApiRerunScenariosForPersonsByIdsRequestFromJSON,
    InternalApiRerunScenariosForPersonsByIdsRequestToJSON,
    InternalApiRerunScenariosForTransactionsByCreatedTimeRangeRequest,
    InternalApiRerunScenariosForTransactionsByCreatedTimeRangeRequestFromJSON,
    InternalApiRerunScenariosForTransactionsByCreatedTimeRangeRequestToJSON,
    InternalApiRerunScenariosForTransactionsByIdRangeRequest,
    InternalApiRerunScenariosForTransactionsByIdRangeRequestFromJSON,
    InternalApiRerunScenariosForTransactionsByIdRangeRequestToJSON,
    InternalApiRerunScenariosForTransactionsByIdsRequest,
    InternalApiRerunScenariosForTransactionsByIdsRequestFromJSON,
    InternalApiRerunScenariosForTransactionsByIdsRequestToJSON,
    InternalApiRerunScenariosForTransactionsByTimestampRangeRequest,
    InternalApiRerunScenariosForTransactionsByTimestampRangeRequestFromJSON,
    InternalApiRerunScenariosForTransactionsByTimestampRangeRequestToJSON,
    InternalApiSetFinalRiskRangesRequest,
    InternalApiSetFinalRiskRangesRequestFromJSON,
    InternalApiSetFinalRiskRangesRequestToJSON,
} from '../models';

export interface RerunPeriodicScenarioRequest {
    internalApiRerunPeriodicScenarioRequest: InternalApiRerunPeriodicScenarioRequest;
}

export interface RerunPeriodicScenarioForPeriodRequest {
    internalApiRerunPeriodicScenarioForPeriodRequest: InternalApiRerunPeriodicScenarioForPeriodRequest;
}

export interface RerunScenariosForPersonsByIdsRequest {
    internalApiRerunScenariosForPersonsByIdsRequest: InternalApiRerunScenariosForPersonsByIdsRequest;
}

export interface RerunScenariosForTransactionsByCreatedTimeRangeRequest {
    internalApiRerunScenariosForTransactionsByCreatedTimeRangeRequest: InternalApiRerunScenariosForTransactionsByCreatedTimeRangeRequest;
}

export interface RerunScenariosForTransactionsByIdRangeRequest {
    internalApiRerunScenariosForTransactionsByIdRangeRequest: InternalApiRerunScenariosForTransactionsByIdRangeRequest;
}

export interface RerunScenariosForTransactionsByIdsRequest {
    internalApiRerunScenariosForTransactionsByIdsRequest: InternalApiRerunScenariosForTransactionsByIdsRequest;
}

export interface RerunScenariosForTransactionsByTimestampRangeRequest {
    internalApiRerunScenariosForTransactionsByTimestampRangeRequest: InternalApiRerunScenariosForTransactionsByTimestampRangeRequest;
}

export interface SetFinalRiskRangesRequest {
    internalApiSetFinalRiskRangesRequest: InternalApiSetFinalRiskRangesRequest;
}

/**
 * 
 */
export class EngineeringOperationsApi extends runtime.BaseAPI {

    /**
     * Rerun a periodic scenario
     */
    async rerunPeriodicScenarioRaw(requestParameters: RerunPeriodicScenarioRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.internalApiRerunPeriodicScenarioRequest === null || requestParameters.internalApiRerunPeriodicScenarioRequest === undefined) {
            throw new runtime.RequiredError('internalApiRerunPeriodicScenarioRequest','Required parameter requestParameters.internalApiRerunPeriodicScenarioRequest was null or undefined when calling rerunPeriodicScenario.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/engineering-operations/scenario-rerun/periodic`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InternalApiRerunPeriodicScenarioRequestToJSON(requestParameters.internalApiRerunPeriodicScenarioRequest),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Rerun a periodic scenario
     */
    async rerunPeriodicScenario(requestParameters: RerunPeriodicScenarioRequest, initOverrides?: RequestInit): Promise<void> {
        await this.rerunPeriodicScenarioRaw(requestParameters, initOverrides);
    }

    /**
     * Rerun a periodic scenario for a time period
     */
    async rerunPeriodicScenarioForPeriodRaw(requestParameters: RerunPeriodicScenarioForPeriodRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.internalApiRerunPeriodicScenarioForPeriodRequest === null || requestParameters.internalApiRerunPeriodicScenarioForPeriodRequest === undefined) {
            throw new runtime.RequiredError('internalApiRerunPeriodicScenarioForPeriodRequest','Required parameter requestParameters.internalApiRerunPeriodicScenarioForPeriodRequest was null or undefined when calling rerunPeriodicScenarioForPeriod.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/engineering-operations/scenario-rerun/periodic-for-period`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InternalApiRerunPeriodicScenarioForPeriodRequestToJSON(requestParameters.internalApiRerunPeriodicScenarioForPeriodRequest),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Rerun a periodic scenario for a time period
     */
    async rerunPeriodicScenarioForPeriod(requestParameters: RerunPeriodicScenarioForPeriodRequest, initOverrides?: RequestInit): Promise<void> {
        await this.rerunPeriodicScenarioForPeriodRaw(requestParameters, initOverrides);
    }

    /**
     * Rerun scenarios for persons by IDs
     */
    async rerunScenariosForPersonsByIdsRaw(requestParameters: RerunScenariosForPersonsByIdsRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.internalApiRerunScenariosForPersonsByIdsRequest === null || requestParameters.internalApiRerunScenariosForPersonsByIdsRequest === undefined) {
            throw new runtime.RequiredError('internalApiRerunScenariosForPersonsByIdsRequest','Required parameter requestParameters.internalApiRerunScenariosForPersonsByIdsRequest was null or undefined when calling rerunScenariosForPersonsByIds.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/engineering-operations/scenario-rerun/by-person-ids`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InternalApiRerunScenariosForPersonsByIdsRequestToJSON(requestParameters.internalApiRerunScenariosForPersonsByIdsRequest),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Rerun scenarios for persons by IDs
     */
    async rerunScenariosForPersonsByIds(requestParameters: RerunScenariosForPersonsByIdsRequest, initOverrides?: RequestInit): Promise<void> {
        await this.rerunScenariosForPersonsByIdsRaw(requestParameters, initOverrides);
    }

    /**
     * Rerun scenarios for transactions by created time range
     */
    async rerunScenariosForTransactionsByCreatedTimeRangeRaw(requestParameters: RerunScenariosForTransactionsByCreatedTimeRangeRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.internalApiRerunScenariosForTransactionsByCreatedTimeRangeRequest === null || requestParameters.internalApiRerunScenariosForTransactionsByCreatedTimeRangeRequest === undefined) {
            throw new runtime.RequiredError('internalApiRerunScenariosForTransactionsByCreatedTimeRangeRequest','Required parameter requestParameters.internalApiRerunScenariosForTransactionsByCreatedTimeRangeRequest was null or undefined when calling rerunScenariosForTransactionsByCreatedTimeRange.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/engineering-operations/scenario-rerun/by-transaction-created-time-range`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InternalApiRerunScenariosForTransactionsByCreatedTimeRangeRequestToJSON(requestParameters.internalApiRerunScenariosForTransactionsByCreatedTimeRangeRequest),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Rerun scenarios for transactions by created time range
     */
    async rerunScenariosForTransactionsByCreatedTimeRange(requestParameters: RerunScenariosForTransactionsByCreatedTimeRangeRequest, initOverrides?: RequestInit): Promise<void> {
        await this.rerunScenariosForTransactionsByCreatedTimeRangeRaw(requestParameters, initOverrides);
    }

    /**
     * Rerun scenarios for transactions by ID range
     */
    async rerunScenariosForTransactionsByIdRangeRaw(requestParameters: RerunScenariosForTransactionsByIdRangeRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.internalApiRerunScenariosForTransactionsByIdRangeRequest === null || requestParameters.internalApiRerunScenariosForTransactionsByIdRangeRequest === undefined) {
            throw new runtime.RequiredError('internalApiRerunScenariosForTransactionsByIdRangeRequest','Required parameter requestParameters.internalApiRerunScenariosForTransactionsByIdRangeRequest was null or undefined when calling rerunScenariosForTransactionsByIdRange.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/engineering-operations/scenario-rerun/by-transaction-id-range`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InternalApiRerunScenariosForTransactionsByIdRangeRequestToJSON(requestParameters.internalApiRerunScenariosForTransactionsByIdRangeRequest),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Rerun scenarios for transactions by ID range
     */
    async rerunScenariosForTransactionsByIdRange(requestParameters: RerunScenariosForTransactionsByIdRangeRequest, initOverrides?: RequestInit): Promise<void> {
        await this.rerunScenariosForTransactionsByIdRangeRaw(requestParameters, initOverrides);
    }

    /**
     * Rerun scenarios for transactions by IDs
     */
    async rerunScenariosForTransactionsByIdsRaw(requestParameters: RerunScenariosForTransactionsByIdsRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.internalApiRerunScenariosForTransactionsByIdsRequest === null || requestParameters.internalApiRerunScenariosForTransactionsByIdsRequest === undefined) {
            throw new runtime.RequiredError('internalApiRerunScenariosForTransactionsByIdsRequest','Required parameter requestParameters.internalApiRerunScenariosForTransactionsByIdsRequest was null or undefined when calling rerunScenariosForTransactionsByIds.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/engineering-operations/scenario-rerun/by-transaction-ids`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InternalApiRerunScenariosForTransactionsByIdsRequestToJSON(requestParameters.internalApiRerunScenariosForTransactionsByIdsRequest),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Rerun scenarios for transactions by IDs
     */
    async rerunScenariosForTransactionsByIds(requestParameters: RerunScenariosForTransactionsByIdsRequest, initOverrides?: RequestInit): Promise<void> {
        await this.rerunScenariosForTransactionsByIdsRaw(requestParameters, initOverrides);
    }

    /**
     * Rerun scenarios for transactions by timestamp range
     */
    async rerunScenariosForTransactionsByTimestampRangeRaw(requestParameters: RerunScenariosForTransactionsByTimestampRangeRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.internalApiRerunScenariosForTransactionsByTimestampRangeRequest === null || requestParameters.internalApiRerunScenariosForTransactionsByTimestampRangeRequest === undefined) {
            throw new runtime.RequiredError('internalApiRerunScenariosForTransactionsByTimestampRangeRequest','Required parameter requestParameters.internalApiRerunScenariosForTransactionsByTimestampRangeRequest was null or undefined when calling rerunScenariosForTransactionsByTimestampRange.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/engineering-operations/scenario-rerun/by-transaction-timestamp-range`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InternalApiRerunScenariosForTransactionsByTimestampRangeRequestToJSON(requestParameters.internalApiRerunScenariosForTransactionsByTimestampRangeRequest),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Rerun scenarios for transactions by timestamp range
     */
    async rerunScenariosForTransactionsByTimestampRange(requestParameters: RerunScenariosForTransactionsByTimestampRangeRequest, initOverrides?: RequestInit): Promise<void> {
        await this.rerunScenariosForTransactionsByTimestampRangeRaw(requestParameters, initOverrides);
    }

    /**
     * Set final risk ranges
     */
    async setFinalRiskRangesRaw(requestParameters: SetFinalRiskRangesRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.internalApiSetFinalRiskRangesRequest === null || requestParameters.internalApiSetFinalRiskRangesRequest === undefined) {
            throw new runtime.RequiredError('internalApiSetFinalRiskRangesRequest','Required parameter requestParameters.internalApiSetFinalRiskRangesRequest was null or undefined when calling setFinalRiskRanges.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/engineering-operations/final-risk-range`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InternalApiSetFinalRiskRangesRequestToJSON(requestParameters.internalApiSetFinalRiskRangesRequest),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Set final risk ranges
     */
    async setFinalRiskRanges(requestParameters: SetFinalRiskRangesRequest, initOverrides?: RequestInit): Promise<void> {
        await this.setFinalRiskRangesRaw(requestParameters, initOverrides);
    }

}
